import geolib from "geolib";
import data from "./data.json";

export const getLocationData = value => data.find(e => e.name === value);

export const getLocationSuggestions = value => {
  const inputValue = value.trim().toLowerCase();
  const inputLength = inputValue.length;

  return inputLength === 0
    ? []
    : data.filter(
        m => m.name.toLowerCase().slice(0, inputLength) === inputValue
      );
};

export const getLocationByCoords = coords =>
  geolib.findNearest(
    {
      latitude: coords.latitude,
      longitude: coords.longitude
    },
    getLocations
  );

export const getLocations = data
  .map(({ name, location }) => ({
    [name]: {
      latitude: location.lat,
      longitude: location.lng
    }
  }))
  .reduce((current, next) => Object.assign(current, next));



// WEBPACK FOOTER //
// ./src/services/votedata/index.js